// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as TicketStatus from "../../../../to-be-migrated/domain/types/order/tickets/TicketStatus.bs.js";
import * as TicketRaisedBy from "../entities/TicketRaisedBy.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ReasonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonUtils.bs.js";
import * as StringUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/StringUtils.bs.js";

function execute(param) {
  var params = {};
  var setVal = function (value, key) {
    params[key] = value;
    
  };
  ReasonUtils$Catalyst.tap(param.crn, (function (value) {
          return setVal(value, "crn");
        }));
  ReasonUtils$Catalyst.tap(param.case_number, (function (value) {
          return setVal(value, "case_number");
        }));
  ReasonUtils$Catalyst.tap(param.msisdn, (function (value) {
          return setVal(value, "msisdn");
        }));
  ReasonUtils$Catalyst.tap(param.caller_number, (function (value) {
          return setVal(value, "caller_number");
        }));
  ReasonUtils$Catalyst.tap(param.start_datetime, (function (value) {
          return setVal(Timestamp$Catalyst.toFloat(value).toString(), "start_datetime");
        }));
  ReasonUtils$Catalyst.tap(param.end_datetime, (function (value) {
          return setVal(Timestamp$Catalyst.toFloat(value).toString(), "end_datetime");
        }));
  ReasonUtils$Catalyst.tap(param.ticket_status, (function (value) {
          return setVal(TicketStatus.toString(value), "ticket_status");
        }));
  ReasonUtils$Catalyst.tap(param.geo_region, (function (value) {
          return setVal(value, "geo_region");
        }));
  ReasonUtils$Catalyst.tap(param.raised_by, (function (value) {
          return setVal(TicketRaisedBy.toString(value), "raised_by");
        }));
  return params;
}

var DictEncoder = {
  execute: execute
};

function getFromDict(dict, key, fromString) {
  return Belt_Option.flatMap(Js_dict.get(dict, key), (function (str) {
                if (str.length !== 0) {
                  return Caml_option.some(Curry._1(fromString, str));
                }
                
              }));
}

function getFromDictString(dict, key) {
  return Belt_Option.flatMap(Js_dict.get(dict, key), (function (str) {
                return str;
              }));
}

function getDefaultDateTime(time) {
  if (typeof time === "number") {
    if (time !== 0) {
      return Timestamp$Catalyst.endOf(Timestamp$Catalyst.now(undefined), /* Day */5);
    } else {
      return Timestamp$Catalyst.getDateTimeBeforeElapsedTime(1.0, /* Days */4, Timestamp$Catalyst.startOf(Timestamp$Catalyst.tomorrow(undefined), /* Day */5));
    }
  } else {
    return Timestamp$Catalyst.make(Number(time._0));
  }
}

function execute$1(map) {
  var crn = getFromDictString(map, "crn");
  var case_number = getFromDictString(map, "case_number");
  var caller_number = getFromDictString(map, "caller_number");
  var msisdn = getFromDictString(map, "msisdn");
  return {
          crn: crn,
          case_number: case_number,
          caller_number: caller_number,
          msisdn: msisdn,
          start_datetime: Belt_Option.mapWithDefault(Belt_Option.flatMap(Js_dict.get(map, "start_datetime"), StringUtils$Catalyst.getStringOptional), undefined, (function (date_str) {
                  return Caml_option.some(getDefaultDateTime(/* DateTime */{
                                  _0: date_str
                                }));
                })),
          end_datetime: Belt_Option.mapWithDefault(Belt_Option.flatMap(Js_dict.get(map, "end_datetime"), StringUtils$Catalyst.getStringOptional), undefined, (function (date_str) {
                  return Caml_option.some(getDefaultDateTime(/* DateTime */{
                                  _0: date_str
                                }));
                })),
          ticket_status: getFromDict(map, "ticket_status", TicketStatus.fromString),
          geo_region: getFromDict(map, "geo_region", (function (city) {
                  return window.decodeURIComponent(city);
                })),
          raised_by: TicketRaisedBy.fromString(Js_dict.get(map, "raised_by"))
        };
}

var DictDecoder = {
  getFromDict: getFromDict,
  getFromDictString: getFromDictString,
  getDefaultDateTime: getDefaultDateTime,
  execute: execute$1
};

export {
  DictEncoder ,
  DictDecoder ,
  
}
/* Timestamp-Catalyst Not a pure module */
